<template >
  <div v-loading="loading">

    <el-dialog ref="ssDialog" :show-close="false" :close-on-press-escape="false" :title="getTitle()"
      :visible.sync="showServiceDialog" :close-on-click-modal="false" width="90%" center custom-class="round-dialog">

      <div>
        <el-button class="gradient-button1" type="primary" @click="selectAll">{{ $t("SELECT_ALL") }}</el-button>
      </div>

      <div v-show="!fistTime">
        <p class="service-desc">{{ $t("service_remark2") }} </p>
        <div class="service-notice">

          <p v-show="removeAlertVis"> {{ this.$t("NOTICE_REMOVE_DEPTS_1") }}</p>
        </div>
        <DepartmentCheckbox :deptsData="deptsData2" :checked="true" ref="depts2" @removeAlert="removeAlert"
          :isDisabled="false">
        </DepartmentCheckbox>
        <br />
      </div>

      <div v-if="!fistTime">
        <p class="service-desc">{{ $t("service_remark") }} </p>
      </div>
      <div v-else>
        <br /><br />
      </div>

      <DepartmentCheckbox :deptsData="deptsData1" ref="depts1" :isDisabled="false">
      </DepartmentCheckbox>


      <div v-show="disableDeptList.length > 0">
        <br />
        <p class="service-desc"> {{ $t("OVERSEA_NOT_AVAILABLE") }} </p>
      </div>


      <div v-show="!isMacauAddress">
        <DepartmentCheckbox :deptsData="disableDeptList" ref="depts3" :isDisabled="true">
        </DepartmentCheckbox>
      </div>



      <div slot="footer" class="dialog-footer">

        <div>
          <el-button class="gradient-button1" type="primary" :loading='loading' @click="setUserService">{{ $t("next") }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-card v-show="!showServiceDialog" >
      <el-row class="description">
        <h3>{{ $t('ENQUIRY_DEPTS') }}</h3>
      </el-row>

      <!-- <div class="dept-table-wrapper">
      <el-table :data="tableData" border style="width: 100%" :show-header="false" :row-class-name="tableRowClassName" >
        <div slot="empty" class="empty">
          <span>{{ $t("NO_DATA") }}</span>
        </div>
        <el-table-column>
          <template slot-scope="scope">

            <div>
              <div class="dept_txt">{{ scope.row.name }}</div>
              <pre v-if="scope.row.desc" :class="deptDescClass( scope.row.id)"> {{ scope.row.desc }} </pre>
              <pre v-if="!isMacauAddress && scope.row.oversea" class="dept_desc_txt"> {{ scope.row.oversea }} </pre>
            </div>

          </template>
        </el-table-column>
      </el-table> 
    </div> -->

      <div>
        <ol type="2">

          <div class="confirm-dept-div" v-for="dept in tableData" :key="dept.id">
            <li class="confirm-dept-list">{{ dept.name }}

              <pre v-if="dept.desc" :class="deptDescClass(dept.id)"> {{ dept.desc }} </pre>

              <div v-if="dept.more">
                <pre :style="moreItem.style" v-for="moreItem in dept.more"
                  :key="moreItem.index"> {{ moreItem.text }} </pre>
              </div>


              <pre v-if="!isMacauAddress && dept.oversea" class="dept_desc_txt"> {{ dept.oversea }} </pre>

            </li>

          </div>
        </ol>

      </div>


      <br />
      <div>
        <el-button class="gradient-button1" type="primary" :loading='loading' @click="submitServicesMap">{{ $t("submit") }}</el-button>
        <br />
        <br />
        <el-button class="gradient-button2" type="danger" :loading='loading'  @click="resetServicesMap">{{ $t("back") }}</el-button>
      </div>
    </el-card>


  </div>
</template>

<script>
import { getLocale } from "@/i18n.js";
import { queryDetailData } from "@/api/contact.js";

import {
  getIdList,
  updateServicesAndSync,
  getDeptData,
  getLastSelectedDepts,
} from "@/api/contact.js";

import DepartmentCheckbox from './DepartmentCheckbox.vue';

var deptsList;

function addDept(x) {
  deptsList.push({
    id: x.id,
    zhname: x.zhname, enname: x.enname, ptname: x.ptname,
    zhdesc: x.zhdesc, endesc: x.endesc, ptdesc: x.ptdesc,
    zhoversea: x.zhoversea, enoversea: x.enoversea, ptoversea: x.ptoversea,
    zhmoredetail: x.zhmoredetail, enmoredetail: x.enmoredetail, ptmoredetail: x.ptmoredetail,
  })
}

export default {
  components: { DepartmentCheckbox },
  data() {
    return {
      loading: true,
      isMacauAddress: true,
      showServiceDialog: true,
      idList: [],
      names: {},
      deptsData: [],
      deptsData1: [],
      deptsData2: [],
      disableDeptList: [],
      servicesResult: [],
      tableData: [],

      currentIndex: 0,
      treeProps: {
        children: 'children',
        label: 'label'
      },
      preSelectedDepts: {},
      fistTime: true,
      removeAlertVis: false,
    };
  },

  async mounted() {

    const locale = getLocale();

    await this.getIdListInformation();

    const { data } = await getDeptData();
    this.deptsData = data;

    deptsList = [];
    this.deptsData.forEach(dept => {
      dept.label = dept[locale + 'name'];
      dept.desc = dept[locale + 'desc'];
      dept.moredetail = dept[locale + 'moredetail'];

      if (!this.isMacauAddress) {
        dept.oversea = dept[locale + 'oversea'];
      }
      addDept(dept);
    })

    console.log('depts:', deptsList)

    this.currentIndex = 0;
    this.servicesResult = [];

    const selectedDeptsResult = await getLastSelectedDepts();
    this.preSelectedDepts = selectedDeptsResult.data || {};
    console.log('preSelectedDepts:', this.preSelectedDepts);

    this.$nextTick(() => {
      const interval = setInterval(() => {
        this.loading = false;
        this.showServiceDialogScreen();
        clearInterval(interval)
      }, 500);

    });

  },

  methods: {

    deptDescClass(dept) {
      return dept !== "SAFP" ? "dept_desc_txt" : "dept_desc_txt2";
    },

    tableRowClassName({ rowIndex }) {

      return (rowIndex % 2 == 0) ? 'table-row-0' : 'table-row-1'
    },

    toDeptData(itemKey, more) {

      const locale = getLocale();
      const item = deptsList.find((x) => x.id == itemKey);
      if (!item) {
        return { name: "???", desc: undefined, id: itemKey, oversea: undefined };
      }
      const name = item[locale + "name"];
      const desc = item[locale + "desc"];
      const oversea = item[locale + "oversea"];
      let result = { name, desc, id: itemKey, oversea };
      if (more) { result['more'] = more['ui'] }
      return result;
    },

    async getIdListInformation() {
      const { data } = await getIdList();

      if (data && data.status == "ok") {
        this.idList = data.idList;
        this.names = data.names;
        this.isMacauAddress = data.isMacauAddress;
        console.log('!isMacauAddress:', this.isMacauAddress);
      } else if (data && data.status == "login_require") {
        this.$router.push("/login");
      }

    },

    async getSelectedServicesDetail(depts) {

      const lang = getLocale();

      try {
        const { data } = await queryDetailData(depts, lang);
        if (data && data.status == "ok") {
          return { detail: data.detail, sign: data.sign };
        }
      } catch (error) {
        console.log(error);
        return {};
      }

    },



    async setUserService() {
      this.loading = true;
      let depts = [...this.$refs.depts1.checkedList, ...this.$refs.depts2.checkedList]
      console.log('selected depts:', depts)

      if (depts.length == 0) { return }
      this.idList.forEach(id => {
        this.servicesResult.push({ id, services: depts });
      })

      const  {detail: detailData, sign: detailSign } = await this.getSelectedServicesDetail(depts);
      const deptsData = depts.map(x => this.toDeptData(x, detailData[x]));

      let servicesDetail = {};
      Object.keys(detailData).forEach(dept => {
        servicesDetail[dept] = detailData[dept]['raw'];
      });

      this.servicesDetail = servicesDetail;
      this.detailSign = detailSign;

      console.log('deptsData:', deptsData);

      this.tableData = this.idList.length > 0 ? deptsData : [];
      this.loading = false;
      this.toNextScreen();
    },

    toNextScreen() {
      this.showServiceDialog = false;
      this.services = [];
    },

    getTitle() {
      const name = this.getCurrentName();
      let text = this.$t("SELECT_SHARED_DEPARMENT");
      text = text.replace("XXXXXX", name);
      return text;
    },

    showServiceDialogScreen() {

      const id = this.idList[this.currentIndex];
      const selectedDepts = (this.preSelectedDepts[id] || []);

      this.removeAlertVis = false;
      this.$refs.depts1.reset();
      this.$refs.depts2.reset();

      const fullDeptList = this.deptsData;

      if (this.isMacauAddress) {
        this.disableDeptList = []
      } else {
        this.disableDeptList = fullDeptList.filter(x => x.disableOversea);
      }

      const disableDeptIdList = this.disableDeptList.map(x => x.id);

      this.deptsData1 = fullDeptList.filter(x => !selectedDepts.includes(x.id)).filter(x => !disableDeptIdList.includes(x.id))

      this.deptsData2 = fullDeptList.filter(x => selectedDepts.includes(x.id)).filter(x => !disableDeptIdList.includes(x.id))



      this.fistTime = (selectedDepts.length == 0)

      // display dialog
      // console.log('fullDeptList:', fullDeptList);
      // console.log('dept1:', this.deptsData1);
      // console.log('dept2:', this.deptsData2);
      // console.log('dept3:', this.disableDeptList);
      this.showServiceDialog = true;
    },

    getCurrentName() {
      if (!this.idList || this.currentIndex >= this.idList.length) {
        return "???";
      }
      const id = this.idList[this.currentIndex];
      return this.getNameById(id);
    },

    getNameById(id) {
      const locale = getLocale();
      let name = "";
      if (locale == "zh") {
        name = this.names[id]["cFullname"];
        if (name == "") {
          name = this.names[id]["pFullname"];
        }
      } else {
        name = this.names[id]["pFullname"];
      }
      return name;
    },


    isApp() {
      return window.GovAppBridge || window.webkit;
    },

    startIdentifyVerify(authorizationUrl) {

      if (this.isApp()) {

        window.JsApi.Auth.start({
          accountType: 'PERSONAL',
          identityLevel: 'HIGH',
          authUrl: authorizationUrl
        })

      } else {
        window.location.href = authorizationUrl;
      }

    },

    async submitServicesMap() {
      this.loading = true;
      const lang = getLocale();

      let servicesMap = {};
      this.servicesResult.forEach((s) => (servicesMap[s.id] = s.services));

      try {
        const { data } = await updateServicesAndSync(servicesMap, lang, this.servicesDetail, this.detailSign);

        if (data) {
          if (data.status == "ok") {

            const authorizationUrl = data.authorizationUrl;
            this.startIdentifyVerify(authorizationUrl);

          } else if (data && data.status == "login_require") {
            this.$router.push("/login");
          } else {
            this.showRequestFail();
          }
        } else {
          this.showRequestFail();
        }
      } catch (e) {
        this.showRequestFail();
      } finally {
        this.loading = false;
      }
    },

    async resetServicesMap() {

      this.currentIndex = 0;
      this.servicesResult = [];
      this.showServiceDialogScreen();
    },

    showRequestFail() {
      this.$message.error(this.$t("request_fail"));
    },

    selectAll() {
      this.$refs.depts1.selectAll();
      this.$refs.depts2.selectAll();
    },

    removeAlert(v) {
      this.removeAlertVis = v;
    }
  },
};
</script>


<style>
.dept-table-wrapper {
  border: 1px solid rgba(0, 119, 16, 0.596);
}

.el-table .table-row-0 {
  background: #ffffff;
  color: rgb(62, 63, 62);

}

.el-table .table-row-1 {
  background: rgba(217, 235, 231, 0.8);
  color: rgb(62, 63, 62);
}


.el-checkbox__label {
  word-break: normal;
  text-align: left;
}

.input-select {
  float: left;
  width: 60%;
}

.type-selector {
  width: 40%;
  background-color: #e7f3f7;
  color: #15aada;
  float: left;
}

.other-tips {
  color: rgb(146, 193, 247);
  font-size: 12px;
}

.el-checkbox__label {
  display: inline;
}

.el-checkbox,
.el-checkbox__input {
  white-space: normal;
}

.el-dialog {
  max-width: 400px;
}

.dept-title {
  color: rgb(0, 124, 137);
  border-bottom: 1px solid #e0d8d8;
  font-size: 1.8 rem;
  word-break: normal;
}

.list {
  list-style: none;
  padding: 0.3 rem;
  font-size: 1.6 rem;
  color: #777373e6;
  height: 90%;
  flex: 1;
}

.list-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 2.3 rem;
  cursor: pointer;
}

.main-form {
  min-width: 320px;
}

.service-desc {
  font-size: 18px;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
  text-align: left;
  margin-top: 1.5em;
  margin-bottom: 1em;
}

.service-notice {
  margin: 20px;
  color: #f56c6c;
  word-break: break-word;
}

.service-notice p {
  word-break: break-word;
}
</style>

<style scoped>
span.el-dialog__title {
  font-family: MING-MSCS-DSI !important;
}

ul {
  padding-left: 0px;
}
</style>

<style  lang="scss" scoped>
.dept_txt {
  margin-top: 15px;
}

.dept_desc_txt {
  margin: 1px;
  color: rgb(252, 66, 66);
  text-indent: -7px;
  font-size: 12px;
  word-break: normal;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.dept_desc_txt2 {
  margin: 1px;
  color: rgba(0, 0, 0, 0.8);
  text-indent: -7px;
  font-size: 12px;
  word-break: normal;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.confirm-dept-list {
  margin-top: 20px;
  list-style: disc;
  margin-inline-start: 2em;

  pre {
    font-family: "PingFang SC";
    white-space: pre-line;
    text-indent: 0;
  }

}
</style>

      
